const STATISTICS_BY_CHANNEL = {
  twitter: {
    retweets: {
      singularLabel: 'Retweet',
      pluralLabel: 'Retweets',
    },
    favorites: {
      singularLabel: 'Like',
      pluralLabel: 'Likes',
    },
    mentions: {
      singularLabel: 'Mention',
      pluralLabel: 'Mentions',
    },
    clicks: {
      singularLabel: 'Click',
      pluralLabel: 'Clicks',
    },
    reach_twitter: {
      singularLabel: 'Impression',
      pluralLabel: 'Impressions',
    },
  },
  facebook: {
    likes: {
      singularLabel: 'Like',
      pluralLabel: 'Likes',
    },
    comments: {
      singularLabel: 'Comment',
      pluralLabel: 'Comments',
    },
    shares: {
      singularLabel: 'Share',
      pluralLabel: 'Shares',
    },
    clicks: {
      singularLabel: 'Click',
      pluralLabel: 'Clicks',
    },
    reach: {
      singularLabel: 'Reach',
      pluralLabel: 'Reach',
    },
  },
  instagram: {
    likes: {
      singularLabel: 'Like',
      pluralLabel: 'Likes',
    },
    comments: {
      singularLabel: 'Comment',
      pluralLabel: 'Comments',
    },
  },
  pinterest: {
    repins: {
      singularLabel: 'Save',
      pluralLabel: 'Saves',
    },
  },
  linkedin: {
    likes: {
      singularLabel: 'Like',
      pluralLabel: 'Likes',
    },
    comments: {
      singularLabel: 'Comment',
      pluralLabel: 'Comments',
    },
    clicks: {
      singularLabel: 'Click',
      pluralLabel: 'Clicks',
    },
    reshares: {
      singularLabel: 'Reshare',
      pluralLabel: 'Reshares',
    },
  },
  startPage: {
    linkClicks: {
      singularLabel: 'Link Click',
      pluralLabel: 'Link Clicks',
    },
  },
  youtube: {
    views: {
      singularLabel: 'View',
      pluralLabel: 'Views',
    },
    likes: {
      singularLabel: 'Like',
      pluralLabel: 'Likes',
    },
    comments: {
      singularLabel: 'Comment',
      pluralLabel: 'Comments',
    },
  },
};

module.exports = {
  STATISTICS_BY_CHANNEL,
};
